import React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default () => <span>
<Link to="/blog"><FontAwesomeIcon icon="book" /> See all posts</Link> <br /><a rel="alternate" type="application/rss+xml" href="/rss.xml"><FontAwesomeIcon icon="rss" /> Subscribe to the RSS feed</a>
</span>